module.exports = __webpack_public_path__ + "static/media/mindfulness-for-sleep-large.fe1fab0e.png";